import { apiRequest } from './apiClient.js'
import { loadBackendUpdates } from './logUpdates.js'

const recentSince = () => new Date(Date.now() - 24 * 60 * 60 * 1000).toISOString()

export const logService = {
  backend: ({ levels = 'INFO,WARNING,ERROR,CRITICAL', limit = 500, since, bot_id, cycle_id, stage, ...options } = {}) => {
    const query = new URLSearchParams({ levels, limit: String(limit) })
    for (const [key, value] of Object.entries({ since, bot_id, cycle_id, stage })) {
      if (value) query.set(key, value)
    }
    return loadBackendUpdates(query, options)
  },
  webhooks: ({ limit = 500, ...options } = {}) => loadBackendUpdates(
    new URLSearchParams({ limit: String(limit) }), options, 'webhooks'),
  frontend: ({ levels = 'INFO,WARNING,ERROR,CRITICAL', limit = 500, since = recentSince(), ...options } = {}) => {
    const query = new URLSearchParams({ levels, limit: String(limit), ...(since ? { since } : {}) })
    return apiRequest(`/api/logs/frontend?${query.toString()}`, options)
  },
  runtime: ({ levels = 'WARNING,ERROR,CRITICAL', limit = 500, since = recentSince(), ...options } = {}) => {
    const query = new URLSearchParams({ levels, limit: String(limit), ...(since ? { since } : {}) })
    return apiRequest(`/api/logs/runtime?${query.toString()}`, options)
  },
  clear: (scope, options = {}) => apiRequest(`/api/logs/${encodeURIComponent(scope)}/clear`, options),
  clearAll: (options = {}) => apiRequest('/api/logs/clear-all', options),
  frontendEvent: (level, message, event = {}, options = {}) => apiRequest('/logs/frontend-event', {
    ...options,
    method: 'POST',
    body: JSON.stringify({ level, message, ...event })
  }),
}
